import { Box } from "@mui/material";

export type NavContainerProps = {
  children: React.ReactNode;
};
export const NavContainer = ({ children }: NavContainerProps) => {
  return (
    <Box
      component={"nav"}
      sx={(theme) => ({
        boxShadow: 3,
        height: "100%",
        position: "relative",
        backgroundColor: "primary.main",
        [theme.breakpoints.up("lg")]: {
          left: 0,
        },
      })}
    >
      <Box sx={{ boxSizing: "content-box", padding: "2.5rem 28px 1.875rem 36px" }}>
        <Box src="/assets/images/logo.svg" sx={{ cursor: "pointer" }} alt="" component={"img"} onClick={() => window.location.reload()} />
      </Box>
      <div style={{ display: "flex", flexDirection: "column", overflow: "scroll", height: "calc(100% - 7.1875rem)" }}>{children}</div>
    </Box>
  );
};
